import { includes } from 'lodash'
import { User } from '../types/models'
import { getCookie } from './cookies'

export const DEFAULT_LANGAUGE = 'ko'
const LANGAUGE_KEYS = 'language'
const SUPPORTED_LANGUAGES = ['en', 'ko']

export const getLanguage = (user?: User) => {
  const languageCookie = getCookie(LANGAUGE_KEYS, DEFAULT_LANGAUGE)
  const languageBySession = user?.language

  if (languageBySession && includes(SUPPORTED_LANGUAGES, languageBySession)) {
    return languageBySession
  }

  return includes(SUPPORTED_LANGUAGES, languageCookie) ? languageCookie : DEFAULT_LANGAUGE
}
